module.exports = __webpack_public_path__ + "img/mask-outline.52d6586f.svg";